"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileDocumentType = void 0;
var ProfileDocumentType;
(function (ProfileDocumentType) {
    ProfileDocumentType[ProfileDocumentType["all"] = 0] = "all";
    ProfileDocumentType[ProfileDocumentType["project"] = 1] = "project";
    ProfileDocumentType[ProfileDocumentType["component"] = 2] = "component";
})(ProfileDocumentType || (exports.ProfileDocumentType = ProfileDocumentType = {}));
//# sourceMappingURL=profile.js.map